@if (showCard) {
  <app-content-card [title]="title" [icon]="icon" [color]="color">
    <ng-container *ngTemplateOutlet="listContent"></ng-container>
  </app-content-card>
} @else {
  <ng-container *ngTemplateOutlet="listContent"></ng-container>
}

<ng-template #listContent>
  <div class="data-list-container">
    @if (items.length === 0) {
      <app-empty-state
        [icon]="emptyIcon"
        [title]="emptyMessage"
        subtitle="Utiliza el botón de abajo para agregar elementos"
      ></app-empty-state>
    } @else {
      <div
        class="data-list"
        [class.draggable]="draggable"
        cdkDropList
        (cdkDropListDropped)="onDrop($event)"
      >
        <!-- Header -->
        <div class="data-list-header">
          @for (col of columns; track col.label) {
            <div class="header-cell" [style.flex]="col.width || '1'">
              {{ col.label }}
            </div>
          }
          <div class="header-cell actions-cell">Acciones</div>
        </div>

        <!-- Items -->
        @for (item of items; track $index; let i = $index) {
          <div class="data-list-row" cdkDrag [cdkDragDisabled]="!draggable">
            @if (draggable) {
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
            }
            @for (col of columns; track col.label) {
              <div class="row-cell" [style.flex]="col.width || '1'">
                @if (col.template) {
                  <ng-container
                    *ngTemplateOutlet="
                      col.template;
                      context: { $implicit: item, index: i }
                    "
                  ></ng-container>
                } @else {
                  @if (getValue(item, col.field!); as valor) {
                    {{ valor }}
                  } @else {
                    <span class="no-info">Sin información</span>
                  }
                }
              </div>
            }
            <div class="row-cell actions-cell">
              <button
                irxBotonIcono
                tono="primario"
                (click)="onEdit(i)"
                tooltip="Editar"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                irxBotonIcono
                tono="peligro"
                (click)="onDelete(i)"
                tooltip="Eliminar"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    }

    <!-- Add Button -->
    <div class="add-button-container">
      <app-button
        [matType]="'mat-fab extended'"
        color="primary"
        (click)="onAdd()"
        [text]="addButtonText"
        icon="add"
      ></app-button>
    </div>
  </div>
</ng-template>
